import { configureStore } from '@reduxjs/toolkit';
import { slugDataSlice } from './ReduxFunction'; 

export default configureStore({
      
  reducer: {
    slugData: slugDataSlice.reducer, 
  },
});
